"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const getDisplaySize = (size = 0) => {
  if (size < 0) size = 0
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
  return Number((size / Math.pow(1024, i)).toFixed(2)) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
}; exports.getDisplaySize = getDisplaySize
